import request from './request'

export function listMaterialCoverage(data) {
  return request.post('/production/material-coverages/list', data)
}
export function getMaterialCoverage(id) {
  return request.get('/production/material-coverages/' + id)
}
export function analyzeMaterialCoverage(data) {
  return request.post('/production/material-coverages/analyze', data)
}
export function kitBoard(orderCode) {
  return request.get('/production/material-coverages/kit-board', { params: { orderCode } })
}
